import React, { FC, useEffect, useState } from "react";
import { ReactSortable } from "react-sortablejs";
import "./sortableChapterList.scss";
import CardMenu from "../CardMenu";
import DeleteAlert from "../../DeleteAlert";
import ChapterForm from "../ChapterForm";
import dragTrigger from "../../../../assets/icons/drag-trigger.svg";
import ChapterService from "../../../../services/CourseServices/ChapterService/chapter.service";
import { RouteComponentProps, withRouter } from "react-router";
import { ExamChaptersService } from "../../../../services/ExamService/ChapterService/chapter.service";

interface SortableChapterListProps extends RouteComponentProps{
  list: any;
  setList: any;
  menuText: string;
  setActiveChapter: Function;
  activeChapter: any;
  refreshList: Function;
}

const SortableChapterList: FC<SortableChapterListProps> = (props) => {
  const {
    list,
    setList,
    menuText,
    setActiveChapter,
    activeChapter,
    refreshList,
  } = props;

  const [currentChapter, setCurrentChapter] = useState<any>();
  const [deleteVisible, setDeleteVisible] = useState<boolean>(false);
  const [formVisible, setFormVisible] = useState<boolean>(false);
  const [urlParams, setUrlParams] = useState<any>()
  useEffect(() =>{
      setUrlParams(props.match.params)
  })
  const handleDelete = () => {
      console.log(currentChapter)
    if (props.location.pathname.includes("exams") && urlParams?.subjectId) {
        ExamChaptersService.deleteExamChapter(
            currentChapter?.id,
            () => {
              refreshList();
              setDeleteVisible(false);
            },
            () => {},
        )
    } else {
      ChapterService.deleteChapter(
        currentChapter?.id,
        () => {
          refreshList();
          setDeleteVisible(false);
        },
        () => {},
        () => {}
      ).then();
    }
  };

  const handleSort = (e: any) => {
    let data = {
      chaptor: {
        position: e.newIndex + 1,
      },
    };
    ChapterService.updateChapterPosition(
      e.item.dataset.id,
      data,
      () => {
        refreshList();
      },
      () => {
        refreshList();
      },
      () => {}
    ).then();
  };

  return (
    <>
      <ChapterForm
        title="Edit Chapter"
        visible={formVisible}
        setVisible={setFormVisible}
        data={currentChapter}
        refreshList={refreshList}
      />
      <DeleteAlert
        title={currentChapter?.title}
        detail={""}
        visible={deleteVisible}
        setVisible={setDeleteVisible}
        deleteText="Chapter"
        deleteWarning="This Chapter will be deleted permanently"
        handleDelete={handleDelete}
      />
      <ReactSortable list={list} setList={setList} onSort={handleSort}>
        {list.map((item: any, i: number) => (
          <div key={item.id} className="sortable__container">
            <div className="sortable__trigger">
              <img src={dragTrigger} alt="" />
            </div>
            <div
              className={`sortable__card ${
                item.id === activeChapter?.id ? "active__card" : ""
              }`}
              onClick={() => {
                setActiveChapter(item);
              }}
            >
              <div>
                <div className="sortable__title">
                  <span>{String(item.position).padStart(2, "0")}</span>{" "}
                  {item?.name}
                </div>
                <div
                  className="sortable__menu-trigger"
                  onClick={(event) => {
                    event.stopPropagation();
                    setCurrentChapter(item);
                  }}
                >
                  <CardMenu
                    menuText={menuText}
                    handleEdit={setFormVisible}
                    handleDelete={setDeleteVisible}
                  />
                </div>
              </div>
              <div className="sortable__status">
                <span
                  className={`sortable__status__indicator ${
                    item.isActive ? "active" : "inactive"
                  }`}
                />
                {item.isActive ? "Active" : "Inactive"}
              </div>
              <div className="ml-3 mt-2">ID: {item.id}</div>

            </div>
          </div>
        ))}
      </ReactSortable>
    </>
  );
};

export default withRouter(SortableChapterList);
